import { Boxes } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';

import PartyTabSection from '@/components/common/PartyTabSection';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import { PARTY_TAB_SECTIONS_MAX_ITEMS } from '@/features/party/constants';
import paths from '@/lib/paths';
import useLocalSettings from '@/stores/useLocalSettings';

import useRiskObjects from '../../queries/hooks/useRiskObjects';

import RiskObjectItem from './RiskObjectItem';

export default function RiskObjectsSection() {
  const { t } = useTranslation();

  const { onlyShowRelevant } = useLocalSettings();

  const party = useSelectedParty();
  const {
    analysis: {
      relevant: { riskObjectIds },
    },
  } = useEmail();

  const { data: riskObjects, isLoading } = useRiskObjects(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  const allRiskObjects = Object.values(riskObjects ?? []).flat();

  const shownItems = onlyShowRelevant
    ? allRiskObjects?.filter((riskObject) =>
        riskObjectIds?.includes(riskObject.risk_object_id),
      )
    : allRiskObjects?.slice(0, PARTY_TAB_SECTIONS_MAX_ITEMS);

  return (
    <PartyTabSection
      icon={Boxes}
      title={t('RISK_OBJECTS_TITLE')}
      noItemsMessage={t('RISK_OBJECTS_EMPTY_TITLE')}
      more={generatePath(paths.riskObjects.overview)}
      isLoading={isLoading}
      totalItems={allRiskObjects.length ?? 0}
      relevantItems={riskObjectIds?.length ?? 0}
    >
      {shownItems.map((riskObject) => (
        <RiskObjectItem
          key={riskObject.risk_object_id}
          riskObject={riskObject}
        />
      ))}
    </PartyTabSection>
  );
}
